import logo from "../resources/logo.svg";
import { useNavigate } from "react-router-dom";
import "../css/landingpage.css";
import arrow from "../resources/fast-arrow-down.svg";

function Landingpage() {

    let navigate = useNavigate();

    const KPP = () => (
        <div>
            <img
                src="https://storage.googleapis.com/eggspatzen-data-bucket/news/KPP_26.jpeg"
                alt="KPP"
                className="news_img_2"
            />
            <p className="color_white news_center_img">
                Laura II. & Oliver I.
            </p>
        </div>
    );
    const PP = () => (
        <div>
            <img
                src="https://storage.googleapis.com/eggspatzen-data-bucket/news/PP_26.jpeg"
                alt="PP"
                className="news_img_2"
            />
            <p className="color_white news_center_img">
                Corinna I. & Niklas I.
            </p>
        </div>
    );
    const PPS = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/PPS_2026.jpeg"
            alt="PP"
            className="news_img"
        />
    );

    const PP_26 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/pps/2025_2026.jpg"
            alt="PP_26"
            className="news_img_3"
        />
    );

    const KPP_26 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/pps/2025_2026_kpp.jpg"
            alt="KPP_26"
            className="news_img_3"
        />
    );

    const ROMO = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/ROMO_2026.JPG"
            alt="RoMo"
            className="news_img"
        />
    );

    const KIGA_Treffen = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/KIGA_Treffen_2026.jpg"
            alt="KIGA_Treffen"
            className="news_img"
        />
    );

    const Kinderball = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/Kinderball_26.jpg"
            alt="Kinderball"
            className="news_img"
        />
    );

    const EB = () => (
        <video className="news_img" loop autoPlay muted playsInline>
            <source src="https://storage.googleapis.com/eggspatzen-data-bucket/news/EB_2026.mp4" type="video/mp4" />
        </video>
    );

    const JHV = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/JHV_2026.png"
            alt="JHV"
            className="news_img"
        />
    );

    const BAUM1 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/Christbaum1_2025.jpg"
            alt="Einladung_Chsistbaumverkauf"
            className="news_img_2"
        />
    );

    const BAUM2 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/Christbaum2_2025.jpg"
            alt="Einladung_Chsistbaumverkauf"
            className="news_img_2"
        />
    );

    const Probetraining1 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/Probetraining_2026_1.png"
            alt="Einladung_Probetraining"
            className="news_img_2"
        />
    );
    const Probetraining2 = () => (
        <img
            src="https://storage.googleapis.com/eggspatzen-data-bucket/news/Probetraining_2026_2.png"
            alt="Einladung_Probetraining"
            className="news_img_2"
        />
    );

    return (
        <div className="Landingpage">

            <div className="landingpageContainer">
                <video className="col-sm-4 videoVertical" loop autoPlay muted playsInline>
                    <source src="https://storage.googleapis.com/eggspatzen-data-bucket/Einzug_2026.mov" type="video/mp4" />
                </video>

                <div className="col-sm-8 centerVertical" style={{ marginTop: 10 + 'vh' }}>
                    <img alt="logo" src={logo} className="logo-landingpage"></img>
                    <p>Willkommen bei den Eggspatzen</p>
                    <button id="buchenBtn" onClick={() => navigate("/kontakt")}>Auftritt buchen</button>

                    <div style={{ marginTop: 20 + 'vh' }} >
                        <img alt="down" src={arrow} style={{ height: 40 + 'px' }} className="bounce2"></img>
                    </div>

                    <video className="col resizeVideo" loop autoPlay muted playsInline>
                        <source src="https://storage.googleapis.com/eggspatzen-data-bucket/confetti.mp4" type="video/mp4" />
                    </video>
                </div>

            </div>

            <div className="landingpageContainer2">
                <div className="col-12">
                    <div className="pagecontent news">News</div>

                    <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <h1 className="heading_midsize color_white">
                            Einladung zur Jahreshauptversammlung am 07.06.2026
                        </h1>
                        <p className="color_white news_center_img">Am Sonntag, den 07.06.2026, findet unsere Jahreshauptversammlung beim Heindl Wirt statt.</p>
                        <p className="color_white news_center_img">Hierzu sind alle Mitglieder des Vereins herzlich eingeladen, insbesondere auch die Kinder, Jugendlichen und Eltern.</p>
                    </div>
                    <div className="col-sm-12 ppContainer">
                        <JHV></JHV>
                    </div>

                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <p className="heading_midsize color_white">
                            Einladung zum Probetraining der großen Garde <br /> am 28.03.2026 um 17 Uhr
                        </p>
                        <p className="color_white news_center_img">
                            Die Veranstaltung findet im Gemeindezentrum am Feuerwehrhaus in Egweil statt.
                        </p>
                    </div>
                    <div className="row">
                        <div className="news_center_img">
                            <Probetraining1></Probetraining1>
                            <Probetraining2></Probetraining2>
                        </div>
                    </div> */}

                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <h1 className="heading_midsize color_white">
                            Einladung zum 3. Kindergardetreffen am 23.01.2026
                        </h1>
                        <p className="color_white news_center_img">Am Freitag, den 23.01.2026, findet unser 3. Kindergardetreffen im Egweiler Sportheim statt.</p>
                    </div>
                    <div className="col-sm-12 ppContainer">
                        <KIGA_Treffen></KIGA_Treffen>
                    </div> */}


                    <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <h1 className="heading_midsize color_white">
                            Prinzenpaare der Saison 2026
                        </h1>
                        <p className="color_white news_center_img">Am Freitag, den 09.01.2026, wurde die Faschingssaison bei den Eggspatzen offiziell eröffnet.</p>
                        <p className="color_white news_center_img">Wir freuen uns auf eine tolle, unvergessliche und unfallfreie Saison!</p>
                    </div>
                    <div className="col-sm-12 news_center_img">
                        <div className="col-sm-12 ppContainer">
                            <PP_26></PP_26>
                            <KPP_26></KPP_26>
                        </div>
                    </div>

                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <h1 className="heading_midsize color_white">
                            Einladung zum Kinderball
                        </h1>
                        <p className="color_white news_center_img">Am Samstag, den 07.02.2026, findet der Kinderball im Heindlwirt statt.</p>
                        <p className="color_white news_center_img">Neben dem Auftritt des gesamten Hofstaats der Eggspatzen gibt es außerdem eine Kostümprämierung.</p>
                    </div>
                    <div className="col-sm-12 ppContainer">
                        <Kinderball></Kinderball>
                    </div> */}

                    {/* <div className="col-sm-12">
                        <p className="heading_midsize color_white">
                            Einladung zum Rosenmontagsumzug <br />am 16.02.2026
                        </p>
                        <p className="color_white news_center_img">
                            Der Umzug beginnt um 13:30 Uhr.
                        </p>
                        <p className="color_white news_center_img">
                            Die Anmeldung zum Umzug erfolgt <u className="color_white">ausschließlich</u> über rosenmontag@eggspatzen.de</p>
                    </div>
                    <div className="col-sm-12 news_center_img">
                        <ROMO></ROMO>
                    </div> */}

                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <h1 className="heading_midsize color_white">
                            Die Prinzenpaare der Saison 2026
                        </h1>
                        <p className="color_white news_center_img">Der große Hofstaat wird in der kommenden Saison von Prinzessin Corinna I. aus Schernfeld und Prinz Niklas I. aus Egweil angeführt.</p>
                        <p className="color_white news_center_img">Im kleinen Hofstaat regieren Laura II. aus Bergen und Oliver I. aus Egweil.</p>
                    </div>
                    <div className="col-sm-12 news_center_img">
                        <PPS></PPS>
                        <div className="col-sm-12 ppContainer">
                            <PP></PP>
                            <KPP></KPP>
                        </div>
                    </div> */}


                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <p className="heading_midsize color_white">
                            Einladung zum Christbaumverkauf <br /> am 13.12.2025 und 14.12.2025
                        </p>
                        <p className="color_white news_center_img">
                            Die Veranstaltung findet im Hof beim Heindlwirt in Egweil statt.
                        </p>
                    </div>
                    <div className="row">
                        <div className="news_center_img">
                            <BAUM2></BAUM2>
                            <BAUM1></BAUM1>
                        </div>
                    </div> */}


                    {/* <div className="col-sm-12" style={{ marginTop: 30 + 'px' }}>
                        <p className="heading_midsize color_white">
                            Einladung zum Eröffnungsball am 09.01.2026
                        </p>
                        <p className="color_white news_center_img">Karten können beim Christbaumverkauf oder im Onlineshop erworben werden.</p>
                        <p className="color_white news_center_img" ><a className="color_white" href="https://shop.snapticket.de/event/eroffnungsball-20216-p2ymep">Hier geht's zum Online-Shop</a></p>
                    </div>

                    <div className="col-sm-12 news_center_img">
                        <EB> </EB>
                    </div> */}


                </div>

                <img src={logo} className="imageResize"></img>
                <div>
                    .
                </div>
            </div>

        </div>
    );
}

export default Landingpage;